import { constants } from '@bedc/constants';
import { iotsUtils } from '@bedc/core';

export const StageId = iotsUtils.fromList(constants.transaction.stage.reportIds);
